import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

/**
 * Allow actions according to sharing type
 * @param {node} children The element to be rendered
 * @param {array} subject Contains all sharing type
 */
const SharingAbility = ({ children, subject, allowed }) => {
  const sharingType = useSelector(
    (state) => state.config?.settings?.core?.partnership?.sharing_type
  );

  const isAllowed = () => {
    if (subject?.includes(sharingType) || allowed || sharingType == undefined) {
      return true;
    }
  };

  return isAllowed() ? children : null;
};

SharingAbility.propTypes = {
  allowed: PropTypes.bool,
  subject: PropTypes.array.isRequired,
  children: PropTypes.node.isRequired,
};

SharingAbility.defaultProps = {
  allowed: false,
  subject: [],
};

export default SharingAbility;
